module.exports = __webpack_public_path__ + "static/media/dollar-sign-solid.1a693c1b.svg";